// ELEVE_CART_ACTIONS (Issue #5996 / #6096): snippets/eleve-freeship-gap-filler.liquid のボタン処理。
// ドロワーは innerHTML で再描画される（theme.js xMiniCart.reLoad）ため、ボタン個別ではなく document へ委譲する。
// カート更新の手順はテーマ標準（frequently-bought-together.js / product-list.js）に合わせる:
// waitForCartUpdate で排他 → sections 付きで add.js → reRenderSections → currentItemCount 同期。
// （#5996 Opusレビュー S4: reLoad だけでは他のカート操作と競合し、件数の内部状態がズレる）
(function () {
  if (window.__eleveGapFillerBound) return;
  window.__eleveGapFillerBound = true;

  function showError(btn, message) {
    var box =
      btn.closest(".eleve-gap-filler") || btn.closest(".eleve-cart-set");
    var el = box && box.querySelector(".eleve-gf-error");
    if (el) {
      el.textContent = message;
      el.style.display = "block";
    }
  }

  function helper() {
    return window.Alpine && window.Alpine.store("xCartHelper");
  }

  function cartJson(root) {
    return fetch(root + "cart.js", { headers: { Accept: "application/json" } }).then(
      function (r) {
        if (!r.ok) throw new Error("カートを確認できませんでした");
        return r.json();
      },
    );
  }

  // 「単品variant_idかつproperties無し」の行から removals（[{id, quantity}]）の数量を減らす更新を組み立てる。
  // line item key は割引の再計算やセット追加で変わり得るため、ボタンに埋めた古い key は使わず、
  // 直前に取り直した /cart.js の今の key を使う。足りなければ null（カートが変わったので触らない）
  function planUpdates(cart, removals) {
    var updates = {};
    var items = (cart && cart.items) || [];
    for (var i = 0; i < removals.length; i++) {
      var remaining = Number(removals[i].quantity);
      for (var j = 0; j < items.length && remaining > 0; j++) {
        var it = items[j];
        var hasProps = it.properties && Object.keys(it.properties).length > 0;
        if (Number(it.variant_id) !== Number(removals[i].id) || hasProps) continue;
        var already = updates[it.key] === undefined ? it.quantity : updates[it.key];
        var take = Math.min(already, remaining);
        updates[it.key] = already - take;
        remaining -= take;
      }
      if (remaining > 0) return null;
    }
    return updates;
  }

  // 失敗後にカートを描き直す（add.js だけ成功した状態を画面に反映する）。
  // sections が無い応答（422等）は Alpine の xMiniCart.reLoad か再読み込みに任せる
  function redrawCart(h, sections) {
    if (h && h.reRenderSections && sections) {
      h.reRenderSections(sections);
    } else if (window.Alpine && window.Alpine.store("xMiniCart")) {
      window.Alpine.store("xMiniCart").reLoad();
    } else {
      window.location.reload();
    }
  }

  // セットへの入れ替え（#6096 / #6546）: セットを先に入れてから単品を減らす
  document.addEventListener("click", async function (e) {
    var btn = e.target.closest && e.target.closest(".eleve-set-swap");
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = "入れ替え中…";
    var h = helper();
    // セットを追加した後かどうか。追加後の失敗ではボタンを戻さない（もう一度押すとセットが2個になる）
    var setAdded = false;
    try {
      if (h && h.waitForCartUpdate) await h.waitForCartUpdate();
      window.updatingCart = true;
      var root =
        window.Shopify && window.Shopify.routes
          ? window.Shopify.routes.root
          : "/";
      var removals = JSON.parse(btn.dataset.removals || "[]");
      // 選べる塩あめセット（#6546）: 味の内訳を line item properties で渡す。
      // 3袋セットは data-properties を持たないので従来どおり properties 無しで入れる
      var setItem = { id: Number(btn.dataset.variantId), quantity: 1 };
      if (btn.dataset.properties) {
        var props;
        try {
          props = JSON.parse(btn.dataset.properties);
        } catch (parseErr) {
          props = null;
        }
        // 内訳が読めないままセットを入れると発送時に中身が分からない。カートを触る前に止める
        if (!props || typeof props !== "object") {
          throw new Error("味の内訳を読み取れませんでした");
        }
        setItem.properties = props;
      }
      // 追加の前に、減らす単品が今のカートに揃っているか確かめる（揃っていなければ何も触らない）
      if (planUpdates(await cartJson(root), removals) === null) {
        throw new Error(
          "カートの内容が変わりました。カートを確認してからもう一度お試しください",
        );
      }
      var sections =
        h && h.getSectionsToRender
          ? h.getSectionsToRender().map(function (s) {
              return s.id;
            })
          : undefined;
      // 先にセットを入れてから単品を減らす。逆順だと add.js 失敗時に
      // 「単品だけ消えてセットが入らない」片道事故になる（#6096レビュー指摘4）
      var addRes = await fetch(root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items: [setItem] }),
      });
      var addData = await addRes.json().catch(function () {
        return {};
      });
      if (!addRes.ok) {
        throw new Error(
          addData.description ||
            addData.message ||
            "セットを追加できませんでした",
        );
      }
      setAdded = true;
      // line item key は割引の再計算等で変わり得る。追加後に取り直した「今の key」で単品を減らす
      var updates = planUpdates(await cartJson(root), removals);
      if (updates === null) {
        throw new Error(
          "カートの内容が変わったため単品を減らせませんでした（セットは追加済みです。カートをご確認ください）",
        );
      }
      var res = await fetch(root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ updates: updates, sections: sections }),
      });
      var updData = await res.json().catch(function () {
        return {};
      });
      if (!res.ok) {
        throw new Error(
          (updData.description || updData.message || "単品を減らせませんでした") +
            "（セットは追加済みです。カートをご確認ください）",
        );
      }
      if (h && h.reRenderSections) {
        h.reRenderSections(updData.sections);
        var bubble2 = document.getElementById("cart-icon-bubble");
        if (bubble2) h.currentItemCount = parseInt(bubble2.innerHTML, 10);
      } else if (window.Alpine && window.Alpine.store("xMiniCart")) {
        window.Alpine.store("xMiniCart").reLoad();
      } else {
        window.location.reload();
      }
      document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
    } catch (err) {
      console.error("[eleve-set-swap]", err);
      var msg = err.message || "入れ替えできませんでした";
      if (setAdded && msg.indexOf("セットは追加済み") < 0) {
        msg += "（セットは追加済みです。カートをご確認ください）";
      }
      showError(btn, msg);
      if (setAdded) {
        // セットは入っている。ボタンは無効のまま（再押下でセットが2個になる）にして、実際のカートを描き直す
        btn.textContent = "カートをご確認ください";
        try {
          redrawCart(h, undefined);
        } catch (redrawErr) {
          console.error("[eleve-set-swap] redraw", redrawErr);
        }
      } else {
        btn.textContent = label;
        btn.disabled = false;
      }
    } finally {
      window.updatingCart = false;
    }
  });

  document.addEventListener("click", async function (e) {
    var btn = e.target.closest && e.target.closest(".eleve-gf-add");
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = "追加中…";
    var h = helper();
    try {
      if (h && h.waitForCartUpdate) await h.waitForCartUpdate();
      window.updatingCart = true;
      var root =
        window.Shopify && window.Shopify.routes
          ? window.Shopify.routes.root
          : "/";
      var body = {
        items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
      };
      if (h && h.getSectionsToRender) {
        body.sections = h.getSectionsToRender().map(function (s) {
          return s.id;
        });
      }
      var res = await fetch(root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(body),
      });
      var data = await res.json().catch(function () {
        return {};
      });
      if (!res.ok) {
        throw new Error(
          data.description || data.message || "追加できませんでした",
        );
      }
      if (h && h.reRenderSections) {
        h.reRenderSections(data.sections);
        var bubble = document.getElementById("cart-icon-bubble");
        if (bubble) h.currentItemCount = parseInt(bubble.innerHTML, 10);
      } else if (window.Alpine && window.Alpine.store("xMiniCart")) {
        window.Alpine.store("xMiniCart").reLoad();
      } else {
        window.location.reload();
      }
      document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
    } catch (err) {
      console.error("[eleve-gap-filler]", err);
      showError(btn, err.message || "追加できませんでした");
      btn.textContent = label;
      btn.disabled = false;
    } finally {
      window.updatingCart = false;
    }
  });
})();
